import { SpaEntityStickyBar } from './SpaEntityStickyBar';

export default SpaEntityStickyBar;
